import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api.js';
import { t, wanneer } from '../i18n.js';
import DomeinControle from './DomeinControle.jsx';

/**
 * Beheer › Klanten › Maildomein (docs/ontwerp/snelle-start.md): de maildomeinen van een klant en of ze op orde zijn, en
 * bij een proefklant de einddatum en *Omzetten naar klant*. ZERO controleert alleen wat het domein openbaar maakt.
 */
export default function KlantDomeinen({ klant, opnieuw }) {
  const q = useQuery({ queryKey: ['klant-domeinen', klant.code], queryFn: () => api.klantDomeinen(klant.code) });
  const [nieuw, zetNieuw] = useState('');
  const [melding, zetMelding] = useState(null);
  const [bezig, zetBezig] = useState(false);
  const doe = async (fn, goed) => {
    zetMelding(null); zetBezig(true);
    try { await fn(); if (goed) zetMelding({ goed: true, tekst: goed }); }
    catch (e) { zetMelding({ goed: false, tekst: t(e.details ? Object.values(e.details)[0] : e.message) }); }
    finally { zetBezig(false); q.refetch(); }
  };
  if (q.isPending) return <p className="muted">{t('Laden…')}</p>;
  if (q.isError) return <div className="melder rood">{t(q.error.message)}</div>;
  const { trialUntil, domains } = q.data.data;
  return (
    <div>
      {melding && <div className={`melder ${melding.goed ? 'blauw' : 'rood'}`} style={{ marginBottom: 10 }}>{melding.tekst}</div>}
      {trialUntil && (
        <div className="callout" style={{ marginBottom: 14 }}>
          {t('Proefklant tot {datum}. Neemt de klant het af, zet hem dan om; daarna een sensor (of syslog via de NAT van ADTS), bronnen en modules.', { datum: wanneer(trialUntil) })}
          <div className="actions"><button type="button" className="btn primary" disabled={bezig}
            onClick={() => doe(async () => { await api.zetOmNaarKlant(klant.code); opnieuw?.(); }, t('Omgezet naar klant.'))}>{t('Omzetten naar klant')}</button></div>
        </div>
      )}
      <p className="muted">{t('ADTS ZERO controleert elke dag of mail en website van het domein op orde zijn: SPF, DMARC, DKIM, MTA-STS, DNSSEC, CAA en het certificaat. Alleen wat het domein openbaar maakt; er wordt niets gescand.')}{' '}
        <Link to="/status">{t('Bekijk het op de beveiligingsstatus')}</Link></p>
      <form className="form" style={{ display: 'flex', gap: 8, margin: '12px 0 18px' }} onSubmit={(e) => { e.preventDefault(); doe(async () => { await api.voegDomeinToe(klant.code, nieuw.trim()); zetNieuw(''); }); }}>
        <input className="input mono" value={nieuw} onChange={(e) => zetNieuw(e.target.value)} placeholder="noordkade.nl" aria-label={t('Maildomein')} style={{ maxWidth: 280 }} />
        <button className="btn" disabled={bezig || nieuw.trim().length < 3}>{bezig ? t('Bezig…') : t('Toevoegen en controleren')}</button>
      </form>
      {!domains.length ? <p className="empty">{t('Nog geen maildomein.')}</p> : domains.map((d) => (
        <div key={d.domain}>
          <DomeinControle d={d} />
          <div className="actions" style={{ marginTop: 8 }}>
            <button type="button" className="btn" disabled={bezig} onClick={() => doe(() => api.controleerDomein(klant.code, d.domain))}>{t('Opnieuw controleren')}</button>
            <button type="button" className="btn danger" disabled={bezig} onClick={() => doe(() => api.verwijderDomein(klant.code, d.domain))}>{t('Verwijderen')}</button>
          </div>
        </div>
      ))}
    </div>
  );
}
